module.exports = __webpack_public_path__ + "img/Bank BTPN.942c4a01.png";